import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class PreviewButton extends PureComponent {
  render() {
    const { className, children, primary, ...others } = this.props;
    const cls = classNames({
      "weui-form-preview__btn": true,
      "weui-form-preview__btn_default": !primary,
      "weui-form-preview__btn_primary": primary
    }, className);

    return (
      <a role="button" className={ cls } { ...others }>{ children }</a>
    );
  }
}
